<template>
    <div class="popover-container" id='fishersci-offline'>
        <div class='popover-title'>{{(this.fsAgentAvailableData?.chatLiveOffline)}}</div>
        <div class='popover-content' v-if="!fsAgentAvailableData?.holidayOfflineMessage">
          {{ fsAgentAvailableData?.offlineMessage }}
             </div>
        <div class='popover-content' v-if="fsAgentAvailableData?.holidayOfflineMessage">
          {{ fsAgentAvailableData?.holidayOfflineMessage }}
            </div>
            <div class='popover-businessHours'>
                  <span class='popover-bus-days'>{{(this.fsAgentAvailableData?.businessHours?.weekDays)}}</span>
                  <span class='popover-bus-hrs'>{{this.fsAgentAvailableData?.businessHours?.hours}} {{(this.fsAgentAvailableData?.businessHours?.timeZone)}}</span>
                  </div>
                <div class='popover-actions'>
                    <a class='popover-btn-contactus' role='button' target='_blank' :href=(this.fsAgentAvailableData?.contactURL)>{{(this.fsAgentAvailableData?.contactUs) }}</a>
                </div>
        </div>
</template>

<script>
export default {
  name: 'ModelComponentOffline',
  data () {
    return {
      holidayOfflineMessage: this.fsAgentAvailableData?.holidayOfflineMessage ?? false
    }
  },
  props: {
    fsAgentAvailableData: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>
.popover-container {
  z-index: 9999;
  visibility: visible;
  margin: 0px;
  position: fixed;
  right: 100px;
  bottom: 54px;
  max-width: 350px;
  border: 1px solid #e5e5e5;
  background: #ffffff;
  box-shadow: 0px 6px 8px 0px rgba(34, 34, 34, 0.1);
  padding: 27px 33px 33px 24px;
  color: #222;

  &.popover-visible {
    visibility: visible;
  }

  .popover-title {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 21px;
    margin-bottom: 8px;
  }

  .popover-content {
    color: #545454;
    font-size: 12px;
    letter-spacing: 0px;
    line-height: 17px;
    width: 266px;
    margin-bottom: 10px;
  }

  .popover-businessHours {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 17px;
    display: flex;
    justify-content: space-between;
    margin: 15px 0 22px;

    .popover-bus-days {
      align-self: flex-start;
    }

    .popover-bus-hrs {
      align-self: flex-end;
      margin-right: 5px;
    }
  }

  .popover-actions {
    .popover-btn-contactus,
    button {
      background-color: #fff;
      border: 1px solid #b2b2b2;
      border-radius: 4px;
      padding: 7px 15px;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0px;
      line-height: 21px;
      text-align: center;
      display: inline-block;
      margin-right: 15px;
      text-decoration: none;
    }

    .popover-btn-contactus {
      color: #1e8ae7 !important;
    }
    .popover-btn-contactus:hover {
      color: #000 !important
    }

    button {
      color: #545454;
    }
  }
}

</style>
